import React from 'react';
import { withTranslation, WithTranslation } from '@wix/wix-i18n-config';
import s from './Footer.scss';
import { WixLogo } from './FooterIcons';
import { openNewTab } from '../../services/window-utils';

class Footer extends React.Component<WithTranslation> {
  onClickOnWixCom = () => openNewTab('https://www.wix.com');

  render() {
    const { t } = this.props;

    return (
      <div className={s.strip} data-hook="footer-strip">
        <div className={s.root} data-hook="footer">
          <div className={s.separatorHorizontal} />
          <div className={s.logo}>
            <button
              data-hook="footer-logo"
              onClick={this.onClickOnWixCom}
              tabIndex={0}
              aria-pressed="false"
              aria-label="Wix.Com"
            >
              <WixLogo />
            </button>
          </div>
          <div
            className={s.rightReserved}
            data-hook="footer-rightReserved"
            onClick={this.onClickOnWixCom}
          >
            {t('footer.rightReserved')}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Footer);
